/*******************************************************************************
 * LOGER S.R.L.
 *
 * Proyecto Smaci San Nicolas
 * Fecha: 25/04/2019
 * Autor: Marco Abecasis
 *
 * RESUMEN:
 *  Componente contenedor principal. O sea, el menu.
 ******************************************************************************/
import { Component, OnInit, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralInfoService } from '../services/general-info.service';
import { AuthenticationServiceService } from 'src/app/services/authentication-service.service';
import { globalData } from '../data/general-objects';

///////////////////////////////////////////////////////////////////////////////
// ENUMERADORES INTERNOS
///////////////////////////////////////////////////////////////////////////////

export enum ExpandedItems {
  NONE,
  CLIMA,
  AGUA,
  // ENERGIA,
  // CLOACA,
  // LUMINARIA,
  // SEGURIDAD,
  // WIFI,
  // SUBE,
  // IMPUESTOS,
  // TRANSITO,
  // SEGUIMIENTO,
  USUARIO,
  ADMINISTRAR,
  // AUDITOR,
  // STOCK_EQUIPOS,
  DATACENTER,
  UNDEFINED,
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit, OnDestroy {

  /////////////////////////////////////////////////////////////////////////////
  // FIELDS
  /////////////////////////////////////////////////////////////////////////////

  private interval;
  tituloPrincipal: string;
  expandedMenu: ExpandedItems = ExpandedItems.NONE;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );


  /////////////////////////////////////////////////////////////////////////////
  // CONSTRUCTOR Y CICLO DE VIDA
  /////////////////////////////////////////////////////////////////////////////

  constructor(
    private breakpointObserver: BreakpointObserver,
    private generalInfoService: GeneralInfoService,
    public authService: AuthenticationServiceService
    ) {}

    ngOnInit() {
      this.generalInfoService.tituloPrincipal$.subscribe(tituloPrincipal => this.tituloPrincipal = tituloPrincipal);
      this.StartTokenTimer();
      //set the current language
      let lang = this.generalInfoService.getActiveLanguage();
      this.generalInfoService.useLanguage(lang);
    }

    ngOnDestroy() {
      this.StopTokenTimer();
    }

  /////////////////////////////////////////////////////////////////////////////
  // METODOS DE CONTROL DE MENUES
  /////////////////////////////////////////////////////////////////////////////

    IsExpanded(menuExpand: ExpandedItems): boolean {
     // console.log('IsExpanded ', this.expandedMenu)
      return (menuExpand === this.expandedMenu);
    }

    ToggleExpand(menuExpand: ExpandedItems) {
      if (menuExpand === this.expandedMenu) {
        this.expandedMenu = ExpandedItems.NONE;
      } else {
        this.expandedMenu = menuExpand;
      }
    //  console.log('ToggleExpand ', this.expandedMenu)
    }

    ConvertToExpandItem(item: string): ExpandedItems {
      const option = item.toUpperCase();
      switch (option) {
        case 'NONE': return ExpandedItems.NONE;
        case 'CLIMA': return ExpandedItems.CLIMA;
        case 'USUARIO': return ExpandedItems.USUARIO;
        case 'ADMINISTRAR': return ExpandedItems.ADMINISTRAR;
      }

      return ExpandedItems.UNDEFINED;
    }

    Logout() {
      this.authService.logout();
      this.expandedMenu = ExpandedItems.NONE;
    }

    LoggedIn() {
      this.expandedMenu = ExpandedItems.NONE;
    }



    ///////////////////////////////////////////////////////////////////////////
    // METODOS DE CONTROL DE TOKEN
    ///////////////////////////////////////////////////////////////////////////

    StartTokenTimer() {
      // console.log('timer iniciado');
      this.authService.renewToken();

      this.interval = setInterval(() => {
        if (this.authService.isUserLoggedIn) {
          this.authService.renewToken();
        }
        // console.log('new Token ' + this.authService.currentUserValue.token);
      }, globalData.tokenRenewInterval);
    }

    StopTokenTimer() {
      clearInterval(this.interval);
      // console.log('Timer Terminado');
    }
}
